export default {
  resource:{
    zh: {
      title:"班组",
      groupNo: "班组编号",
      groupName: "班组名称",
      remark:	"备注",
      bc:	"班次",
      exType: "班次类型",
      exType1: "普通班次",
      exType2: "转班班次",
      exDate: "转班日期",
      nullbh:"请先输入班组编号！",
      nullbz:"请先输入班组名称！",
      nullbc:"请先输入班次！",
      nameExist: "班组已经存在，请检查！",
      dayHour:"每天上班时间"
    }
  },
  delConf:["groupName"],
  delKeys:["autoid"],
  params: {
    groupNo:{
      key: "groupNo",
      data: null,
      method: "Equal",
      type: "text"
    },
    groupName:{
      key: "groupName",
      data: null,
      method: "Contains",
      type: "text"
    }
  },
  listDefine: [
    "groupNo","groupName", {key: "dayHour",formatter: "fstime"},"remark"
  ],
  bodyClass: "table-select", //table-multiselect table-select
  list: [],
  defaultSortName: "groupNo",
  defaultSortOrder: "asc",
  sortName: "groupNo",
  sortOrder: "asc",
  pageNo: 1,
  pageSize: 18,
  rowCount: 127,
  url: "shiftgroup/"
 
}
